import React from "react";
import PropTypes from "prop-types";
import "../css/style.css";

import { connect } from "react-redux";
import QRDialog from "./QRDialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import i18next from "i18next";
import { CircularProgress } from "@material-ui/core";
import { userActions, appActions } from "../_actions";
import PartItem from "./PartItem";
import { userService, confService } from "../_services";
import { store, history } from "../_helpers";
import { storeData, setStore } from "../store.js";
import { SendButton, TextFieldCell, Snack } from "../_components";

class TicketsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: false, tickets:[], nameF:'',dateF:'',qrData:null,openQR:false };
  }

  componentDidMount() {
    //this.props.dispatch(userActions.conf_student_list(0));
    this.LoadTickets();
  }
  
  LoadTickets() {
      
      let self = this;
        userService.getWrapper('api/ticket/',
        (data) => {
           //self.props.dispatch(userActions.conf_list());
          //confService.confListParticipants(false);
          
           const ticket_data = data.data.map(function(item){

               const conf = item.ticket_type.conference;
               
               const confName = conf.name;
                    const conf_dates = `${conf.start_time
                      .substr(0, 10)
                      .split("-")
                      .reverse()
                      .join("-")} - ${conf.end_time
                      .substr(0, 10)
                      .split("-")
                      .reverse()
                      .join("-")}`;
               
               return {id:item.id,conf_name:confName,dates:conf_dates,name:item.ticket_type.name,cost:item.ticket_type.cost}
               
               
           });               
           
           self.setState({tickets:ticket_data});
           
        },
        (error) => {
            self.props.dispatch(userActions.set_error(error));
            
        }
      );
  }
  
  ticketClick = (id) => {
	  const { classes, dispatch } = this.props;
	  
	  userService.getWrapper(
      "api/ticket/"+id,
      (data) => {
        
		console.log(data);
		if (data.data.img)
		{
			this.setState({qrData:data.data.img,openQR:true});
		}
      },
      (error) => {
        dispatch(userActions.set_error(error));
      }
    );
  }

  
  /*
  <div className="tbl__item tbl__item--text">
                <input type="text" placeholder="Поиск по билету" />
              </div>
              <div className="tbl__item tbl__item--text">
                <input type="text" placeholder="Поиск по цене" />
              </div>
*/


  render() {
    const self = this;
    const { isLoading, tickets, nameF,dateF, qrData, openQR } = this.state;
    const { classes, user } = this.props;

    

    return (
      <div className="layout">
        <div className="layout__contains">
          <h1 className="layout__title">Билеты</h1>
        </div>

        <div className="tbl">
          <div className="tbl__top">
            <div className="tbl__items">
              <div className="tbl__item tbl__item--city">
                <input type="text" placeholder="Поиск по конференции" value={nameF} onChange={(e)=>this.setState({nameF:e.target.value})}/>
              </div>
              <div className="tbl__item tbl__item--text">
                <input type="text" placeholder="Поиск по дате" value={dateF} onChange={(e)=>this.setState({dateF:e.target.value})}/>
              </div>
              
            </div>
          </div>

          <div className="tbl__body">
        {tickets.filter(e=>e.conf_name.indexOf(nameF)>=0).filter(e=>e.dates.indexOf(dateF)>=0).map((item, index) => (
          <PartItem data={item} onItemClick={self.ticketClick}/>
        ))}
      
          </div>
        </div>
		<QRDialog
		  handleClose={() => self.setState({ openQR: false, qrData:null })}
          qrData={qrData}
          dialogOpen={openQR}
        />

        {isLoading && (
          <div className="shadow">
            <div className="shadow_circle">
              <CircularProgress />
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;

  return {
    user,
    app,
    authentication,
  };
}

const connectedTicketsPage = connect(mapStateToProps)(TicketsPage);
export { connectedTicketsPage as TicketsPage };
